import { render, staticRenderFns } from "./mySubmitReview.vue?vue&type=template&id=b8b2813c"
import script from "./mySubmitReview.vue?vue&type=script&lang=js"
export * from "./mySubmitReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports